<i18n>
{
    "ru": {
        "action": {
            "male": {
                "add": "Добавил",
                "publish": "Опубликовал",
                "left_comment": "Оставил комментарий",
                "left_review": "Оставил отзыв"
            },
            "female": {
                "add": "Добавила",
                "publish": "Опубликовала",
                "left_comment": "Оставила комментарий",
                "left_review": "Оставила отзыв"
            },
            "neuter": {
                "publish": "Опубликована"
            }
        },
        "objective": {
            "for": {
                "post": "к записи",
                "news": "к новости",
                "article": "к статье",
                "brand": "о бренде",
                "perfume": "об аромате",
                "shop": "о магазине"
            },
            "neuter": {
                "news": "новость",
                "article": "статья",
                "post": "новая запись",
                "news_tag": "новость с тегом",
                "article_tag": "статья с тегом",
                "news_tags": "новость с тегами",
                "article_tags": "статья с тегами"
            },
            "new": {
                "news": "новость",
                "article": "статью",
                "post": "новую запись",
                "news_tag": "новость с тегом",
                "article_tag": "статью с тегом",
                "news_tags": "новость с тегами",
                "article_tags": "статью с тегами"
            }
        }
    }
}
</i18n>
<template>
    <div class="feed-block">

        <BlockArticle
            v-if="isPost"
            v-bind="getArticleBindings">

            <FeedBlockHeader
                slot="header"
                post
                v-bind="getHeaderBindings" />

        </BlockArticle>

        <BlockReview
            v-else-if="isReview"
            v-bind="getReviewBindings">

            <FeedBlockHeader
                slot="header"
                v-bind="getHeaderBindings" />

        </BlockReview>

        <FeedBlockHeader
            v-else
            single
            v-bind="getHeaderBindings" />

    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import get from 'lodash/get'
import includes from 'lodash/includes'
import filter from 'lodash/filter'
import forEach from 'lodash/forEach'
import map from 'lodash/map'

import BlockReview from '@/components/layout/blocks/BlockReview'
import BlockArticle from '@/components/layout/blocks/BlockArticle'
import FeedBlockHeader from '@/components/feed/FeedBlockHeader'

export default {
    name: 'FeedBlock',
    components: {
        FeedBlockHeader,
        BlockArticle,
        BlockReview
    },
    props: {
        createdAt: {
            type: String,
            default: null
        },
        updatedAt: {
            type: String,
            default: null
        },
        anons: {
            type: String,
            default: null
        },
        entity: {
            type: Object,
            default: null
        },
        entityType: {
            type: String,
            default: null
        },
        subscriptions: {
            type: Array,
            default: null
        },
        openReplies: {
            type: Boolean,
            default: false
        }
    },
    provide() {
        return {
            isPost: this.isPost,
            getSubToUser: this.getSubToUser,
            isSelfItem: this.isSelfItem
        }
    },
    computed: {
        ...mapGetters(['getUserNoImageLarge', 'getNoImage', 'getEntityNoImage']),
        isReview() {
            return includes(this.reviewTypes, this.entityType)
        },
        isPost() {
            return includes(this.postTypes, this.entityType)
        },
        postTypes() {
            return [ 'post', 'article', 'news' ]
        },
        catalogTypes() {
            return [ 'perfume', 'brand', 'shop' ]
        },
        reviewTypes() {
            return [ 'review', 'comment' ]
        },
        primarySub() {
            return this.subscriptions ? this.subscriptions[0] : null
        },
        primaryEntity() {
            return get(this.primarySub, 'entity')
        },
        primaryEntityType() {
            return get(this.primarySub, 'entityType')
        },
        getObjectiveType() {
            let objective = null

            // Если материал
            if (this.isPost) {
                let type = this.entityType

                if (this.getTags) {
                    type += this.getTags.length === 1 ? '_tag' : '_tags'
                }

                return type
            }

            // Если комментарий к материалу
            forEach(this.postTypes, type => {
                const entityExist = get(this.entity, type, false)
                // console.log(this.entity, type, entityExist)

                if (entityExist) {
                    objective = type
                }
            })

            // Если отзыв или комментарий к элементу каталога
            forEach(this.catalogTypes, type => {
                const entityExist = get(this.entity, type, false)
                // console.log(this.entity, type, entityExist)

                if (entityExist) {
                    objective = type
                }
            })

            return objective
        },
        getArticleBindings() {
            const {
                htmlUrl,
                anons,
                description,
                createdBy,
                name,
                picture,
                pictures,
                videos,
                createdAt,
                code,
                cover
            } = this.entity

            const user = get(createdBy, '[0]', createdBy)
            const likes = get(this.entity, 'likes.total')
            const comments = get(this.entity, 'comments.total')

            return {
                code,
                url: htmlUrl,
                description: anons || description,
                userUrl: user.htmlUrl,
                name: user.fullName || user.name,
                title: name,
                source: 'user',
                authorPhoto: user.photo,
                withoutHeader: this.isWithoutHeader(),
                entityType: this.entityType,
                picture: get(cover, 'url', get(picture, 'url')),
                smallDescription: this.entityType !== 'post',
                date: createdAt,
                pictures: pictures || [],
                videos: videos || [],
                size: 'feed',
                subscriptions: this.primarySub,
                likes,
                comments
            }
        },
        getHeaderBindings() {
            return {
                subscriptions: this.subscriptions,
                pictureFormat: this.getPictureFormat,
                pictureHref: this.getPictureHref,
                pictureUrl: this.getPictureUrl,
                anons: this.getAnons,
                name: this.getHeaderName,
                tags: this.getTags,
                rating: get(this.entity, 'stars', 0),
                online: this.getUserOnlineStatus,
                articleTitle: this.getArticleTitle,
                entity: this.entity
            }
        },
        getReviewBindings() {
            return {
                idPrefix: 'feed-block',
                comment: this.entity,
                url: this.getPostUrl,
                page: this.getObjectiveType,
                code: this.getPostCode,
                maxRows: 20,
                openReplies: this.openReplies
            }
        },
        getSubToUser() {
            const userSubs = filter(this.subscriptions, ['entityType', 'user'])

            return userSubs.length>0 ? userSubs[0] : null
        },
        getTags() {
            const tagsSubs = filter(this.subscriptions, ['entityType', 'tag'])

            if (tagsSubs && tagsSubs.length) {
                return map(tagsSubs, 'entity')

            }
            return null
        },
        getAnons() {
            // Если с бека уже прилетел анонс, выводим его
            if (this.anons) return this.anons

            let action, key

            switch(this.entityType) {
            case 'comment':
                action = 'left_comment'
                key = 'for'
                break
            case 'review':
                action = 'left_review'
                key = 'for'
                break
            case 'news':
            case 'article':
                action = 'publish'
                key = this.getSubToUser || this.isSelfItem ? 'new' : 'neuter'
                break
            case 'post':
                action = 'add'
                key = 'new'
                break
            }

            return this.getActionKey(action, key) + ' ' + this.getObjectiveKey(key)
        },
        getHeaderName() {
            if (!this.getUser){
                if(this.isSelfItem){
                // return get(this.entity, 'createdBy.fullName')
                    if(Array.isArray(this.entity.createdBy)){
                        return get(this.entity.createdBy[0], 'fullName', false)
                    }else{
                        return get(this.entity, 'createdBy.fullName', false)
                    }
                }else{
                    return null
                }
            }else{
                return get(this.getUser, 'fullName', get(this.getUser, 'name'))
            }
        },
        getUser() {
            return this.isDetailEntityPage ? get(this.entity, 'createdBy', null) : get(this.getSubToUser, 'entity', null)
        },
        getPictureHref() {
            if(this.isSelfItem || this.isDetailEntityPage)
                return Array.isArray(this.entity.createdBy) ? get(this.entity.createdBy[0], 'htmlUrl', null) : get(this.entity, 'createdBy.htmlUrl', null)

            if(this.primaryEntityType === 'user') {
                return get(this.getUser, 'htmlUrl')
            }

            if (this.entityType === 'note' && this.primaryEntityType === 'noteGroup')
                return get(this.entity, 'htmlUrl')

            return get(this.primaryEntity, 'htmlUrl')
        },
        getPictureUrl() {
            if (this.isPost){
                if(this.subscriptions && this.getUser){
                    return get(this.getUser, 'photo.url', this.getUserNoImageLarge)
                }else{
                    return Array.isArray(this.entity.createdBy) ? get(this.entity.createdBy[0], 'photo.url', this.getUserNoImageLarge) : get(this.entity, 'createdBy.photo.url', this.getUserNoImageLarge)
                }
            }

            if (this.isReview){
                if(this.isSelfItem || this.getUser){
                    return get(this.entity, 'createdBy.photo.url', this.getUserNoImageLarge)
                }else{
                    if(get(this.entity, 'perfume', false))
                        return get(this.entity, 'perfume.picture.url', this.getEntityNoImage('perfume'))
                    if(get(this.entity, 'brand', false))
                        return get(this.entity, 'brand.logo.url', this.getEntityNoImage('brand'))
                    if(get(this.entity, 'shop', false))
                        return get(this.entity, 'shop.logo.url', this.getEntityNoImage('shop'))
                }
            }

            // if (this.isReview && this.primaryEntityType === 'user')
            //     return get(this.entity, 'createdBy.photo.url', this.getUserNoImageLarge)

            if (this.entityType === 'note' && this.primaryEntityType === 'noteGroup')
                return get(this.entity, 'picture.url', this.getEntityNoImage(this.primaryEntityType))

            return get(
                this.primaryEntity,
                'logo.url',
                get(this.primaryEntity, 'picture.url', this.getEntityNoImage(this.primaryEntityType))
            )
        },
        getPictureFormat() {

            let format = 'circle'

            // if (this.isReview && this.subscriptions)
            //     return format

            if(this.getUser || this.isSelfItem)
                return format

            switch(this.primaryEntityType) {
            case 'brand':
            case 'shop':
                format = 'rectangle';
                break;
            case 'perfume':
                format = 'square'
                break;
            }

            return format
        },
        getPost() {
            const type = this.getObjectiveType

            return type ? get(this.entity, type, null) : '';
        },
        getPostCode() {
            return get(this.getPost, 'code', null)
        },
        getPostUrl() {
            let htmlUrl = null

            if (this.entityType === 'comment') {
                if (this.getPost && this.getPost.htmlUrl) htmlUrl = this.getPost.htmlUrl
            }

            if (this.entityType === 'review') {
                if (this.entity.perfume) {
                    htmlUrl = this.entity.perfume.htmlUrl
                } else if (this.entity.brand) {
                    htmlUrl = this.entity.brand.htmlUrl
                } else if (this.entity.shop) {
                    htmlUrl = this.entity.shop.htmlUrl
                } else if (this.primarySub.entity && this.primarySub.entity.htmlUrl) {
                    htmlUrl = this.primarySub.entity.htmlUrl
                }
            }

            return htmlUrl
        },
        getUserOnlineStatus() {
            // if(this.subscriptions && this.subscriptions.filter(obj => { return obj.entityType === 'user'}).length && this.entity){
            if(this.entity && (this.isSelfItem || this.getUser)){
                if(Array.isArray(this.entity.createdBy)){
                    return get(this.entity.createdBy[0], 'isOnline', false)
                }else{
                    return get(this.entity, 'createdBy.isOnline', false)
                }
            }

            return false
        },
        getArticleTitle() {
            if(this.entityType === 'comment' && !this.anons && !('post' in this.entity)){
                const post = this.getPost

                if(post){
                    const { htmlUrl, name } = post
                    return `<a href="${htmlUrl}">${name}</a>`
                }

                return false
            }

            return false
        },
        isSelfItem(){
            const createdById = Array.isArray(this.entity.createdBy) ? get(this.entity, 'createdBy[0].id', null) : get(this.entity, 'createdBy.id', null)
            return createdById === this.$auth.user.id
        },
        isDetailEntityPage(){
            return this.$route.path !== '/feed/';
        }
    },
    methods: {
        isWithoutHeader() {

            if(!this.getSubToUser){
                return this.isSelfItem
            }

            if (this.entityType === 'post') return true

            const tagsLength = get(this.getTags, 'length', 0)

            return tagsLength < 2
        },
        getActionKey(action, key) {
            // Если есть подписка на юзера
            let gender;

            if(key !== 'neuter' && this.entity && 'createdBy' in this.entity){
                gender = Array.isArray(this.entity.createdBy) ? this.entity.createdBy[0].gender : this.entity.createdBy.gender

                if(!gender)
                    gender = 'male'

            }else{
                gender = 'neuter'
            }

            return this.$t('action.' + gender + '.' + action)
        },
        getObjectiveKey(key) {
            const type = this.getObjectiveType;

            if (!type)
                return ''

            let str = this.$t('objective.' + key + '.' + type)

            if (this.entityType === 'comment') {
                const post = this.getPost

                if (post) {
                    if (type === 'post') {
                        const user = get(
                            post,
                            'createdBy[0]',
                            get(post, 'createdBy')
                        )

                        if (user) {
                            const {
                                fullName,
                                name
                            } = user

                            const { htmlUrl } = post

                            str += ` <a href="${htmlUrl}">${fullName || name}</a>`
                        }
                    }
                }
            } else if (this.isReview) {
                switch (type) {
                case 'perfume':
                case 'brand':
                case 'shop':
                    // eslint-disable-next-line
                    const name = get(this.entity, type + '.name', null);
                    // eslint-disable-next-line
                    const link = get(this.entity, type + '.htmlUrl', null);

                    if(!(this.getSubToUser && name || this.isSelfItem)){
                        str += ' ' + [
                            link ? '<a href="'+ link +'">' : null,
                            name,
                            link ? '</a>' : null,
                        ].join('');
                    };
                    break;
                }
            }

            return str;
        },
    }
}
</script>
